export default __webpack_public_path__ + "static/media/micro_big.7b8d2462.png";